module.exports = __webpack_public_path__ + "static/img/home.4789df61.png";